import { render, staticRenderFns } from "./fenjian.vue?vue&type=template&id=78fad775&"
import script from "./fenjian.vue?vue&type=script&lang=js&"
export * from "./fenjian.vue?vue&type=script&lang=js&"
import style0 from "./fenjian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports